import axios from "axios";
import { useFormikContext } from "formik";
import { useEffect, useState } from "react";

export const DetectCardNumber = ({ setInstallement }) => {
  const { values, setFieldValue } = useFormikContext();
  const [cardNumberListen, setCardNumberListen] = useState("");
  useEffect(() => {
    if (values.cardNumber.length >= 7)
      setCardNumberListen(values.cardNumber.slice(0, 7).replace("-", ""));
    else setCardNumberListen("");
  }, [values]);

  useEffect(() => {
    if (cardNumberListen.length == 6 && values?.price) {
      axios
        .post("/api/InstallmentInfo", {
          binNumber: cardNumberListen,
          price: values?.price,
        })
        .then((e) => {
          if (e.data.status == "success") {
            setInstallement(e.data.installmentDetails[0].installmentPrices);
            setFieldValue("installement", 0);
          } else {
            setInstallement([]);
            setFieldValue("installement", 0);
          }
        });
    } else setInstallement([]);
  }, [cardNumberListen, values?.price]);

  return null;
};
